import HeroContainer from '../ui/hero-container';
import { Footer } from '../Footer';
import HeaderAlt from '../HeaderAlt';

export default function Terms() {
  return (
    <>
      <HeaderAlt />
      <HeroContainer>
        <div className="container max-w-[368px] !pb-[33px]  !pt-[49px] text-center md:!mx-[208px] md:!px-0 md:py-[87px] md:text-left">
          <span className="hero-title fredokaOne">Terms & Conditions</span>
        </div>
      </HeroContainer>
      <div className="mx-6 md:!ml-[208px] ">
        <div className="mb-6 mt-12">
          <span className="!mt-12 font-[Fredoka] text-4xl font-medium text-[#012E33]">About</span>
        </div>
        <div className="mb-12 flex max-w-[815px] flex-col gap-6 lg:mb-44">
          <p className=" text-base text-[#678285]">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut pretium sed lorem nec
            feugiat. Nam placerat, elit eget rutrum vulputate, ex nulla aliquam enim, vitae auctor
            enim sapien a justo. Mauris vestibulum ligula eros, sit amet rutrum est fermentum nec.
            Proin eget rutrum odio. Praesent tempus volutpat aliquet. Proin eu mi erat. Aenean porta
            enim lectus, quis tincidunt ligula consequat quis. Curabitur iaculis egestas
            condimentum. Vivamus vestibulum varius nunc, vitae pretium urna bibendum quis.
            Vestibulum bibendum pellentesque odio. Phasellus enim justo, sodales at egestas nec,
            malesuada vitae quam. Donec quis ipsum at lacus dictum vulputate ut vitae nisl. Nunc eu
            felis lacus.
          </p>
          <p className=" text-base text-[#678285]">
            Donec interdum quis nisi eget faucibus. Donec congue neque eget pretium egestas. Orci
            varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Proin
            fermentum ultrices volutpat. Phasellus libero justo, tempus ut augue sit amet, fringilla
            facilisis arcu. Quisque bibendum orci vel elit faucibus, sed eleifend magna
            sollicitudin. Aenean sollicitudin felis vitae tellus tristique fermentum. Nunc nulla
            ante, rhoncus sed ultricies sit amet, condimentum a turpis. Etiam ac leo et mauris
            fringilla pharetra vel at purus.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}
